// extracted by mini-css-extract-plugin
export default {"LandingPageHeader":"Header_LandingPageHeader__48y39"};